/** 色を決めるのに要る最小限。/map は sourceRows、カード配車は deliveries から渡す */
export type TruckColorSource = {
  truckId: number;
  truckColor: string | null;
};

/**
 * truckId ごとの表示色を決める。
 *
 * Why not 最初に見た行で確定する: 同一車両の行は複数あり（回転・delivery）、
 * 先頭が null だと後続の非 null を無視してしまう（色が付いているのに付かなく見える）。
 * **最初の非 null** を採り、見つからなければ null のままにする。
 */
export function buildTruckColorMap(rows: TruckColorSource[]): Map<number, string | null> {
  const m = new Map<number, string | null>();

  rows.forEach((r) => {
    // 既に非 null が入っていれば動かさない（最初の非 null を維持する）
    if (m.get(r.truckId) != null) return;
    m.set(r.truckId, r.truckColor ?? null);
  });

  return m;
}
